import React from "react";

interface Props {
  note: server.dto.Note
}

const NotePreview = ({ note }: Props) => {
  const domParser = new DOMParser();

  // For a preview, we don't actually want render the HTML. We just want the raw text.
  // For example if the text is very large, it will overflow
  const dom = domParser.parseFromString(note.body ?? "", "text/html");
  const text = dom.documentElement.innerText;
  const [firstLine] = text.split("\n");

  const previewLine = firstLine ? (firstLine.slice(0, 100) + "…") : "";
  return <>
    <div>{note.title}</div>
    <div className="s1_small truncate">{previewLine}</div>
  </>;
};

export default NotePreview;